import FORM_AUTH_TYPES from './formAuthTypes.js';

/**
 * Whether an app from the catalog connects only through its provider's own sign-in page (OAuth 2):
 * it lists `oAuth2` and no method the connect form can fill. Such an app is connected from a
 * conversation; any other is connected with the form on its connection page.
 */
const signsInOnProviderSite = (app) => {
  const authTypes = Array.isArray(app?.authTypes) ? app.authTypes : [];

  return authTypes.includes('oAuth2') && !authTypes.some((authType) => FORM_AUTH_TYPES.includes(authType));
};

export default signsInOnProviderSite;
